import '@mantine/core/styles.css';
import './core/i18n';
import { MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './core/auth';
import { SetupProblem } from './core/SetupProblem';
import { createDb, DbContext } from './core/supabase';
import { theme } from './ui/theme';

const db = createDb(import.meta.env);
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true } },
});

const root = document.getElementById('root');
if (root !== null) {
  createRoot(root).render(
    <StrictMode>
      <MantineProvider theme={theme} defaultColorScheme="light">
        {db === null ? (
          <SetupProblem />
        ) : (
          <DbContext.Provider value={db}>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <App />
              </AuthProvider>
            </QueryClientProvider>
          </DbContext.Provider>
        )}
      </MantineProvider>
    </StrictMode>,
  );
}
